import BaseModel from "../api/models/BaseModel";

/**
 * CourseModuleVideoDictionary
 */
export default class CourseModuleVideoDictionary extends BaseModel{
    
    constructor() {
        super();

        this.WATCHED     = 1;
        this.NOT_WATCHED = 0;
    }

}